export default {
  SAVE_USUARIO(state, payload) {
    state.usuario = payload;
  },
  LOGOUT(state) {
    state.usuario = undefined;
  },
  PUSH_USUARIO(state, payload) {
    state.usuarios.push(payload);
  },
  PUSH_PRODUTO(state, payload) {
    state.produtos.push(payload);
  },
  DELETE_PRODUTO(state, id) {
    const index = state.produtos.findIndex(produto => produto.id === id);
    state.produtos.splice(index, 1);
  },
  PUSH_ANUNCIO(state, payload) {
    state.anuncios.push(payload);
  },
  DELETE_ANUNCIO(state, id) {
    const index = state.anuncios.findIndex(anuncio => anuncio.id === id);
    state.anuncios.splice(index, 1);
  }
};
